'use strict';

angular.module('libraryModule')
.controller('LibraryBasketModalController', LibraryBasketModalController);

function LibraryBasketModalController (
    $scope,
    model,
    File,
    BasketService
) {
    $scope.model = model;
    $scope.basketService = BasketService;
    $scope.basket = BasketService.get();
    File.bindAll({asset_id: model.id}, $scope, 'files');

    $scope.toggleInBasket = toggleInBasket;
    $scope.toggleAllInBasket = toggleAllInBasket;
    $scope.getButtonLabel = getButtonLabel;
    $scope.canAddAll = canAddAll;

    function toggleInBasket (file)
    {
        const action = file.in_basket ? 'remove' : 'add';
        BasketService[action](file);
    }

    function toggleAllInBasket (files)
    {
        const action = canAddAll() ? 'add' : 'remove';
        files.map((file) => BasketService[action](file))
    }

    function canAddAll ()
    {
        return $scope.files.some((file) => !BasketService.inBasket(file.id));
    }

    function getButtonLabel (file)
    {
        const inBasket = BasketService.inBasket(file.id);
        return inBasket ? 'Remove from kitbag' : 'Add to kitbag';
    }
}
